module.exports = __webpack_public_path__ + "static/img/job.b6da1ffe.svg";